import { InboxEntryType } from '.';

import { RefreshedInboxEntry, SocketData, SocketPayload } from './SocketData';

export type StaleEntry = {
  type: InboxEntryType;
  data: RefreshedInboxEntry;
  payload: SocketPayload;
  isSameUser: boolean;
};

export function isStaleEntry(data: SocketData): data is StaleEntry {
  return (
    typeof data === 'object' &&
    data !== null &&
    data !== undefined &&
    'type' in data &&
    'payload' in data &&
    'isSameUser' in data &&
    (data.payload?.deleted ?? false) === false
    // Add additional checks if necessary
  );
}
